import sensors from 'sa-sdk-javascript'
const document = window.document
const YRBridge = window.YRBridge
const base = 'https://yrd.yixinfund.com'
// const inApp = /((YRLC)|(ZDD)).*?\/((\d+)|(\d+\.\d+\.\d+))/i.test(
//   navigator.userAgent
// )
console.log(process.env.NODE_ENV)
const isDev = process.env.NODE_ENV === 'development'
/**
 * 初始化神策上报
 * @param {*} channelCode String
 */
export const initSensors = (channelCode) => {
  const serverUrlList = ['https://sadata.yixin.com/sa?project=puzejijin_production']
  if (channelCode) {
    const channelLev1 = channelCode.substring(0, 3)
    if (channelLev1 === '002') { // 星火
      serverUrlList.push('https://sadata.yixin.com/sa?project=xhlcs')
    }
    if (channelLev1 === '003') { // 宜人
      serverUrlList.push('https://sadata.yixin.com/sa?project=yirencaifu')
    }
    if (channelLev1 === '005') { // 宜信
      serverUrlList.push('https://sadata.yixin.com/sa?project=production')
    }
  }
  if (sensors) {
    try {
      // 其中show_log参数上线时应删掉
      sensors.init({
        use_app_track: true,
        is_track_single_page: true,
        name: 'sensors',
        server_url: serverUrlList,
        // server_url: 'https://scdata.yixin.com/sa?project=default',
        // 如果神策代码中 `sensorsdata.min.js` 版本是 1.13.1 及以前版本，必须须配置 heatmap_url，高于此版本不需要配置。heatmap_url 神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。
        heatmap_url: 'https://yrd.yixinfund.com/widget/sa-sdk/heatmap.min.js',
        // 如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置 web_url。 web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。
        // web_url:"神策分析后台地址",
        heatmap: {
          // 是否开启点击图，默认为 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
          // 需要 JSSDK 版本号大于 1.7
          clickmap: 'default',
          // 是否开启触达注意力图，默认为 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
          // 需要 JSSDK 版本号大于 1.9.1
          scroll_notice_map: 'not_collect'
        },
        // show_log: isDev
      })
      sensors.quick('autoTrack')
    } catch (e) {
      console.log(e)
    }
  }
}

/**
 * 修改distinct_id
 * @param {*} code String
 */
export const setSensorsLogin = (code) => {
  if (sensors) {
    try {
      sensors.login(code)
    } catch (e) {
      console.log(e)
    }
  }
}

/**
 * 自定义上报事件
 * @param {*} name String
 * @param {*} params Object
 */
export const updateSensorsSelfEvent = (name, params = {}) => {
  if (sensors) {
    try {
      sensors.track(name, {
        ...params
      })
    } catch (e) {
      console.log(e)
    }
  }
}

export const setTitle = title => {
  document.title = title
  YRBridge.inApp && YRBridge.callHandler('setTitle', { param: title })
}

export const getLinkParams = (params = [], url = window.location.href) => {
  const search = new URL(decodeURI(url)).search
  const resParamsObj = {}
  params.forEach((paramName) => {
    const re = new RegExp('[&,?]' + paramName + '=([^\\&]*)', 'i')
    const a = re.exec(search)
    resParamsObj[paramName] = a == null ? null : unescape(decodeURIComponent(a[1]))
  })
  return resParamsObj
}
// 获取token
export const getDToken = (callback) => {
  YRBridge.getDToken(function (dtoken) {
    if (dtoken) {
      // 获取token后的操作
      callback(dtoken)
      if (window.sessionStorage.getItem('LOGINTIMES') !== null) {
        window.sessionStorage.removeItem('LOGINTIMES')
      }
    } else if (window.sessionStorage.getItem('LOGINTIMES') === '1') {
      // 关闭页面
      YRBridge.callHandler('closeWebview')
    } else {
      YRBridge.callHandler('login')
      window.sessionStorage.setItem('LOGINTIMES', '1')
    }
  })
}

// 端外链接换起
export const linkUnApp = url => {
  window.location.href = base + '/dh/sms/?id=20200312a&type=web_page&np=' + url
}
// 分享
export const share = params => {
  const { img, url, title, desc } = params

  YRBridge.callHandler('showShareBtn', { isShow: 'true', cbName: 'share' })
  YRBridge.registerHandler('share', function (data, responseCallback) {
    window.yrcfShare()
    responseCallback()
  })
  window.YRCF_SHARE = function () {
    var baseShare = {
      img,
      url,
      title,
      desc
    }
    return {
      debug: false,
      title: baseShare.title,
      desc: baseShare.desc,
      img: baseShare.img,
      url: baseShare.url,
      bigPicUrl: baseShare.img,
      smallPicUrl: baseShare.img,
      shareUrl: baseShare.url,
      loginNeed: 1,
      relNeed: 1,
      shareChannels: ['WX', 'FRIEND_CIRCLE']
    }
  }
  !YRBridge.inApp && window.yrcfShare()
}
// 埋点
export const staticEvent = (type, data, from) => {
  try {
    sensors.track(type, { ...data })
  } catch (error) {
    console.warn('自定义埋点异常', error)
  }
}
